import { P2GAlert, P2GBox, P2GIcon } from '@parcel2go/core-ui';
import { P2GGrid } from '@parcel2go/core-ui';
import { P2GText } from '@parcel2go/core-ui';
import { lazy, useMemo } from 'react';
import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { EditType } from './EditType';
import { ErrorCodeIcon } from './ErrorCodeIcon';
import { ErrorCodeIconSrc } from './ErrorCodeIconSrc';
import { ErrorCodeMessage } from './ErrorCodeMessage';
import { ErrorCodeResolutionsByErrors } from './ErrorCodeResolutions';

import ErrorSummary from './ErrorSummary';
import QuickFixWrapper from '../edit/QuickFixWrapper';

const ServiceInformationModal = lazy(() => import('./ServiceInformationModal'));

interface props {
  item: SmartSendItemApiModel;
  variant: 'body2';
  edit: (type: EditType) => void;
  xs?: boolean | 'auto' | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
  sm?: boolean | 'auto' | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
  md?: boolean | 'auto' | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
  lg?: boolean | 'auto' | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
  xl?: boolean | 'auto' | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
  component: 'Grid' | 'Box';
  children: React.ReactNode;
}

const ItemErrorSummary: React.FC<props> = (props) => {
  const itemErrors = useMemo(
    () => ErrorCodeResolutionsByErrors(props.item?.State?.validation?.Errors),
    [props.item?.State?.validation]
  );

  if (!itemErrors || itemErrors.length === 0) {
    return <>{props.children}</>;
  }

  const mainError = itemErrors[0];
  const icon = { icon: <ErrorCodeIcon error={mainError} />, path: ErrorCodeIconSrc(mainError) };

  const alert = (
    <P2GAlert
      type="error"
      icon={
        icon?.icon && (
          <P2GIcon palette="error" size="md">
            {icon.icon}
          </P2GIcon>
        )
      }
    >
      <P2GText variant={props.variant}>
        <strong>
          <ErrorCodeMessage error={mainError} />
        </strong>
      </P2GText>
      <P2GBox mt={1}>
        <QuickFixWrapper error={mainError} item={props.item}>
          <ErrorSummary
            limit={3}
            errors={itemErrors}
            edit={props.edit}
            controls={{
              'SERVICE-UNAVAILABLE': (
                <ServiceInformationModal
                  itemId={props.item.Id}
                  service={props.item.Service}
                  dims={props.item.PackageDimensions}
                  senderIsoCode={props.item.Sender.CountryIsoCode}
                  senderSubdivision={props.item.Sender.CountrySubdivision}
                  recipientIsoCode={props.item.Recipient.CountryIsoCode}
                  recipientSubdivision={props.item.Recipient.CountrySubdivision}
                  currencyCode={props.item.CurrencyCode}
                />
              )
            }}
          />
        </QuickFixWrapper>
      </P2GBox>
    </P2GAlert>
  );

  return props.component == 'Grid' ? (
    <P2GGrid item sm={props.sm} md={props.md} xs={props.xs} lg={props.lg} xl={props.xl}>
      {alert}
    </P2GGrid>
  ) : (
    alert
  );
};
export default ItemErrorSummary;
